<template>
  <div class="user">
    <template v-if="isLogined">
      <div class="flex pointer" @click="onBtn(1)">
        <el-image
          class="userImg"
          :src="$store.state.user.headPhoto || defaultImg"
          alt="用户头像"
          fill="cover"
        />
        <div>
          <div class="t1">{{ $store.state.user.name || "" }}</div>
          <div class="t2">{{ $store.state.user.defaultCompanyName || "" }}</div>
        </div>
      </div>
      <div class="line"></div>
      <div>
        <div class="title">我的功能</div>
        <div class="menuList">
          <div
            v-for="item in btnList"
            :key="item.type"
            class="menuItem pointer"
            @click="onBtn(item.type)"
          >
            <el-image :src="item.icon" alt="icon" />
            <div class="t3">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex pointer" @click="onBtn(1)">
        <el-image
          class="userImg"
          :src="defaultImg"
          alt="用户头像"
          fill="cover"
        />
        <div>
          <div class="t1">欢迎使用</div>
          <div class="t2">宁东工业超市电子商务平台</div>
        </div>
      </div>
      <div class="between btnArea">
        <el-button type="primary" class="signBtn pointer" @click="toLogin()"
          >注册</el-button
        >
        <el-button class="loginBtn pointer" @click="toLogin()">登录</el-button>
      </div>
      <el-divider class="line"></el-divider>
      <div class="column-center mt-16" style="height:100px">
        <!-- <img
          src="@/assets/img/main/home/kefu_qr.jpg"
          alt="APP扫描下载安装"
          width="88px"
        />
        <div class="imgTxt">扫一扫 客服二维码</div> -->
      </div>
      <div class="between mt-16">
        <!-- <div class="tipTxt pointer" @click="consultJump">
          <i class="el-icon-service"></i>
          在线咨询
        </div> -->
        <div class="tipTxt">
          客服电话:
          0951-5918508
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import icon2 from '@/assets/img/main/home/icon-1.png'
import icon3 from '@/assets/img/main/home/icon-2.png'
import icon4 from '@/assets/img/main/home/icon-3.png'
import icon9 from '@/assets/img/main/home/icon-9.png'
import icon7 from '@/assets/img/main/home/icon-7.png'
import icon10 from '@/assets/img/main/home/icon-10.png'
import icon12 from '@/assets/img/main/home/icon-8.png'
import icon16 from '@/assets/img/main/home/icon-5.png'

export default {
  data () {
    return {
      defaultImg: require('@/assets/img/icon.jpg')
    }
  },
  computed: {
    btnList () {
      let list = [
        { label: '订单', icon: icon3, type: 5 },
        // { label: '领用车', icon: icon4, type: 6 },
        // { label: '备件库', icon: icon2, type: 4 },
        // { label: '询价篮', icon: icon7, type: 7 },
        // { label: '设计选型', icon: icon9, type: 9 },
        { label: '浏览历史', icon: icon16, type: 16 },
        { label: '收藏', icon: icon10, type: 10 }
      ]
      if (this.$store.state.user.corpUserInfo.customerId) {
        list = [
          { label: '订单', icon: icon3, type: 5 },
          { label: '浏览历史', icon: icon16, type: 16 },
          // { label: '询价单', icon: icon12, type: 12 },
          // { label: '询价篮', icon: icon7, type: 7 },
          // { label: '设计选型', icon: icon9, type: 9 },
          { label: '收藏', icon: icon10, type: 10 }
        ]
      }
      return list
    },
    isLogined () {
      return this.$store.state.user.userId
    },
    phone () {
      return this.$store.state.app.onlineServe.phone || ''
    }
  },
  methods: {
    onBtn (type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: 'basicInfo'
          })
          break
        case 2:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: 'corpWebsite-myShopCart'
            })
          } else {
            this.$router.push({
              name: 'myShopCart'
            })
          }
          break
        case 4:
          this.$router.push({
            name: 'sparePartsLibrary'
          })
          break
        case 5:
          this.$router.push({
            name: 'orderList'
          })
          break
        case 6:
          this.$router.push({
            name: 'mySpareShopCart'
          })
          break
        case 7:
          this.$router.push({
            path: '/myInquiryCart'
          })
          break
        case 8:
          this.$router.push({
            path: '/personalCenter/inquiryList'
          })
          break
        case 9:
          this.$router.push({
            path: '/personalCenter/meterSelection'
          })
          break
        case 10:
          this.$router.push({
            path: '/personalCenter/myCollection'
          })
          break
        case 12:
          this.$router.push({
            path: '/personalCenter/inquiryList'
          })
          break
        case 16:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: 'corpWebsite-browseHistory'
            })
          } else {
            this.$router.push({
              name: 'browseHistory'
            })
          }
          break
      }
    },
    toLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    // 在线咨询
    consultJump () {
      this.$consultJump(this.$store.state.user)
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  width: 250px;
  height: 320px;
  background: #f6f5fa;
  border-radius: 16px;
  overflow: hidden;
  padding: 20px;
  .userImg {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    margin-right: 12px;
  }
  .t1 {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
  .t2 {
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    color: #333;
  }
  .line {
    height: 1px;
    background: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .title {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 700;
    color: #666;
  }
  .menuList {
    display: flex;
    flex-wrap: wrap;
    .menuItem {
      width: 64px;
      height: 64px;
      background: #fff;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 16px 3px 0;
      .t3 {
        font-family: Alibaba PuHuiTi;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #666;
        margin-top: 4px;
      }
    }
  }
  .column-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .signBtn {
    width: 99px;
    padding: 8px 20px;
    border-radius: 8px;
    background: #2a54d1;
    box-sizing: border-box;
  }
  .loginBtn {
    width: 99px;
    padding: 8px 20px;
    border-radius: 8px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #2a54d1;
  }
  .mt-16 {
    margin-top: 16px;
  }
  .btnArea {
    margin: 20px 0;
  }
  .imgTxt {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    text-align: center;
    color: #2c2c2c;
    margin-top: 4px;
  }
  .tipTxt {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    text-align: center;
    color: #2c2c2c;
    display: flex;
    align-items: center;
    i {
      font-size: 16px;
      margin-right: 2px;
    }
  }
}
</style>
